/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Button, Table } from 'antd';
import usePaginationHook from '../../../../utils/usePagination';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import fitSurveyServices from '../../../../services/fit-survey.services';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FiArrowLeft } from 'react-icons/fi';
import { FaDownload } from 'react-icons/fa';

dayjs.locale('th');

const pageSize = 10;

const LegacySurveyAnswerSelect = () => {
  const {
    data: legacySurveyQuestionAnswerLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();
  const history = useHistory();
  const params = useParams();
  const [loading2, setLoading2] = useState(false);

  fitSurveyServices.useQueryGetLegacySurveyQuestionById(
    { take: pageSize, page, questionId: params.questionId },
    (data) => {
      setData(data.answers);
      setTotal(data.answers.length);
    }
  );

  const { mutate: downloadLegacySurveyQuestionByIdExcel } =
    fitSurveyServices.useMutationDownloadLegacySurveyQuestionByIdExcel(() => {
      setTimeout(() => {
        setLoading2(false);
      }, 600);
    });

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      title: 'รูปภาพ',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (_, record) => (
        <div>
          {record.imageUrl && (
            <img
              alt={record.question}
              src={record.imageUrl}
              style={{
                width: 100,
                height: 100,
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'คำตอบ',
      dataIndex: 'answer',
      key: 'answer',
      render: (_, record) => <span>{record.answer}</span>,
    },
    {
      title: 'ผู้เลือกตอบทั้งหมด',
      dataIndex: 'answer_no',
      key: 'answer_no',
      render: (_, record) => <span>{record.userAnswers.length}</span>,
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <h3
          onClick={() => {
            history.goBack();
          }}
          className="mr-2"
          style={{ cursor: 'pointer' }}
        >
          <FiArrowLeft />
        </h3>
      </div>
      <Panel>
        <PanelHeader>คำตอบ</PanelHeader>
        <PanelBody>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
            }}
            className="mb-2"
          >
            <Button
              onClick={() => {
                setLoading2(true);
                downloadLegacySurveyQuestionByIdExcel({
                  id: params.questionId,
                });
              }}
              loading={loading2}
              type="primary"
            >
              <FaDownload className="mr-2" />
              โหลด excel
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={legacySurveyQuestionAnswerLists.sort((a, b) => {
              return a.index - b.index;
            })}
            style={{ backgroundColor: '#fff' }}
            rowKey="id"
            onChange={({ current }) => {
              setPage(current);
            }}
            pagination={{
              pageSize,
              total,
            }}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {},
              };
            }}
          />
        </PanelBody>
      </Panel>
    </>
  );
};

export default LegacySurveyAnswerSelect;
